import { render, staticRenderFns } from "./planning_modal_example.vue?vue&type=template&id=19585e4c&lang=pug&"
import script from "./planning_modal_example.vue?vue&type=script&lang=coffee&"
export * from "./planning_modal_example.vue?vue&type=script&lang=coffee&"
import style0 from "./planning_modal_example.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./planning_modal_example.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports